import { useWorkspacesList } from "@api/workspace.api";
import {
    MAX_STORED_RECENT_WORKSPACES,
    pickRecentWorkspaces,
} from "@components/navigation/pickRecentWorkspaces";
import {
    ORGANIZATION_USER_CACHE_KEYS,
    useOrganizationUserCache,
} from "@hooks/useOrganizationUserCache";
import { useScope } from "@state/scopeContext.lib";

/**
 * The firm's most recent clients, the client rows of the org side nav.
 * `OrgSideNav` reads them once and shares them with the Clients section and
 * the Actions row's highlight.
 */
export const useRecentClients = () => {
    const { organizationId } = useScope();
    const { data: workspaces } = useWorkspacesList(
        {
            organizationId: organizationId ?? undefined,
            excludeDemoClient: true,
        },
        { enabled: Boolean(organizationId) },
    );
    const [recentIds] = useOrganizationUserCache<string[]>(
        ORGANIZATION_USER_CACHE_KEYS.RECENT_WORKSPACES_CACHE_KEY,
    );

    return pickRecentWorkspaces({
        workspaces: workspaces ?? [],
        recentIds: recentIds ?? [],
        limit: MAX_STORED_RECENT_WORKSPACES,
    });
};

export type RecentClients = ReturnType<typeof useRecentClients>;
